// Humming Shopify theme — interactions

document.addEventListener('DOMContentLoaded', function () {

  // ── Order bump: AJAX add/remove from cart ────────────
  // When checked: adds the companion product to cart via Shopify Cart API.
  // When unchecked: removes it.
  // The variant ID is read from data-bump-variant on the label element.
  var bumpCheck = document.getElementById('bump-check');
  if (bumpCheck) {
    var bumpLabel = bumpCheck.closest('[data-bump-variant]');
    var bumpVariantId = bumpLabel ? parseInt(bumpLabel.dataset.bumpVariant, 10) : 0;

    bumpCheck.addEventListener('change', function () {
      if (!bumpVariantId) return;

      if (this.checked) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: bumpVariantId, quantity: 1 })
        })
        .then(function (r) { return r.json(); })
        .catch(function () {
          bumpCheck.checked = false;
        });
      } else {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: bumpVariantId, quantity: 0 })
        });
      }
    });
  }

  // ── Smooth scroll for anchor links ──────────────────
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var hash = link.getAttribute('href');
      if (hash.length < 2) return;
      var target = document.querySelector(hash);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
